import { Box } from '@mui/material';
import { useState } from 'react';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Layout from '../../../core/ui/layout/Layout';
import TableContainer from '../../../core/ui/table/TableContainer';
import { TableHeader } from '../../../core/ui/table/tableTypes';
import { Paginated } from '../../../core/utils/types';
import { parseQuery } from '../../../core/utils/utility';
import { Impact } from '../impact';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';

const tableHeaders: TableHeader[] = [
  { field: 'amount', label: 'Amount', align: 'left' },
  { field: 'from_date', label: 'From Date', align: 'left' },
  { field: 'to_date', label: 'To Date', align: 'left' },
  { field: 'women_impacted', label: 'Women', align: 'left' },
  { field: 'girls_impacted', label: 'Girls', align: 'left' },
  { field: 'men_impacted', label: 'Men', align: 'left' },
  { field: 'boys_impacted', label: 'Boys', align: 'left' },
  { field: 'donated_by', label: 'Donated By', align: 'left' },
  // { field: 'locations', label: 'Locations', align: 'left' },
];
const ImpactList = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const { fetchData } = useFetchApiData();
  const { callApi } = useSendApiData();

  const handleFetchData = async (query: any, cb: (c: number) => void) => {
    await fetchData(`impacts${parseQuery(query)}`, {
      onSuccess: ({ total, data: apiData }: Paginated<Impact>) => {
        setData(apiData);
        cb(total);
      },
    });
  };

  const handleDelete = async (id: number | string, showMessage = true) => {
    let success = false;

    await callApi({
      endpoint: `auth-ea35a/impacts/${id}`,
      data: {},
      method: 'delete',
      onSuccess: async () => {
        if (showMessage) toastMessage('Impact Removed');
        success = true;
      },
      onError: () => {
        if (showMessage)
          toastError('Something went wrong while deleting. Try again');
      },
    });

    return success;
  };

  return (
    <>
      <Layout>
        <Box sx={{ p: 2 }}>
          <TableContainer
            modelToken="impact"
            tableHeaders={tableHeaders}
            data={data}
            modelLabel="Impacts"
            addRoute="/impacts/create"
            editRoutePrefix="/impacts/edit"
            actions={{
              onFetchData: handleFetchData,
              onDelete: handleDelete,
            }}
            fieldMap={{}}
            settings={{
              canCreate: true,
              canEdit: true,
              canDelete: true,
              canViewItem: false,
            }}
          />
        </Box>
      </Layout>
    </>
  );
};

export default ImpactList;
